<div class="content" role="main">
  <input
    id="colorPicker"
    [style.background]="color"
    [cpPresetColors]="colorBox"
    [(colorPicker)]="color"
    (colorPickerClose)="onColorChanged($event)"
    style="display: none; height: 0"
  />

  @if (showSettings$ | async) {
    <app-settings />
  }
  <div
    [class.headerAndCanvas]="
      !(showSettings$ | async) && (showDescription$ | async)
    "
    [class.headerAndCanvasCollapsed]="
      !(showSettings$ | async) && !(showDescription$ | async)
    "
    [class.hidden]="showSettings$ | async"
  >
    <app-header
      [class.header]="showDescription$ | async"
      [class.headerCollapsed]="!(showDescription$ | async)"
    />
    <div appDrag id="canvas"></div>
  </div>

  <div
    [class.logoContainer]="!(showSettings$ | async)"
    [class.hidden]="showSettings$ | async"
  >
    <span>
      <img src="favicon.ico" height="24" alt="Egon Logo" />
      <a href="https://egon.io" target="_blank"> egon.io</a>
      <span>version: </span>
      <a href="https://egon.io/changelog" target="_blank">{{ version }}</a>
      <span>by </span>
      <img src="assets/logo/wps-icon.ico" height="24" alt="WPS Logo" />
      <a href="https://www.wps.de/" target="_blank">WPS</a>
    </span>

    <span>
      <a href="https://www.wps.de/datenschutz/" target="_blank">Privacy</a>
    </span>

    <span>
      <a href="https://www.wps.de/impressum/" target="_blank">Imprint</a>
    </span>
  </div>
</div>
